import { FC, ReactNode, useMemo } from 'react'
import cn from 'classnames'
import styles from 'components/features/future/FutureInputDecoration/FutureInputDecoration.styl'
import { FutureInputDecorationError } from 'components/features/future/FutureInputDecoration/FutureInputDecorationError'
import { FutureInputLayout } from 'components/features/future/FutureInputDecoration/FutureInputLayout'

type FutureInputDecorationProps = {
  label?: ReactNode
  disabled?: boolean
  error?: string
  note?: ReactNode
  units?: string
  isPremium?: boolean
  className?: string
  wrapperClassName?: string
}

export const FutureInputDecoration: FC<FutureInputDecorationProps> = (props) => {
  const { children, label, disabled, error, note, units, className, wrapperClassName } = props

  const noteChild = useMemo(() => {
    if (note) {
      return (
        <div className={ styles.note }>
          { note }
        </div>
      )
    }

    return null
  }, [note])

  const unitsChild = useMemo(() => {
    if (units) {
      return (
        <div className={ styles.units }>
          { units }
        </div>
      )
    }

    return null
  }, [units])

  const errorChild = useMemo(() => {
    if (error) {
      return (
        <FutureInputDecorationError type={ error } />
      )
    }

    return null
  }, [error])


  return (
    <label className={ cn(wrapperClassName, { [styles.isDisabled]: disabled }) }>
      <FutureInputLayout
        label={ label }
        note={ noteChild }
        error={ errorChild }
        units={ unitsChild }
        className={ className }
      >
        { children }
      </FutureInputLayout>
    </label>
  )
}
